import clsx from 'clsx'
import React, {useContext} from 'react'
import {makeStyles} from 'external/material'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import {faCaretUp} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import Box from '@mui/material/Box'
import {TeacherContext} from 'teacher/context'
import References from './references'
import Indicator from './indicator'

const useStyles = makeStyles(styles)
const useAccordionStyles = makeStyles(accordionStyles)
const useAccordionSummaryStyles = makeStyles(accordionSummaryStyles)
const useAccordionDetailStyles = makeStyles(accordionDetailStyles)

export default function Expectation(props) {

  const classes = useStyles()
  const accordionClasses = useAccordionStyles()
  const accordionSummaryClasses = useAccordionSummaryStyles()
  const accordionDetailClasses = useAccordionDetailStyles()
  const {expectation, withReferences} = props
  const hasIndicators = expectation.indicators.length > 0
  return (
    <Accordion classes={accordionClasses} defaultExpanded={true} >
     <AccordionSummary classes={accordionSummaryClasses} expandIcon={<FontAwesomeIcon icon={faCaretUp}/>} >
       <Box className={clsx(classes.centered, classes.description)}>{expectation.description}</Box>
       {!hasIndicators && (
       <Box className={clsx(classes.centered, classes.references)}>
         <References references={expectation.references} withReferences={withReferences} />
       </Box>)}
     </AccordionSummary>
     <AccordionDetails classes={accordionDetailClasses} >
        {hasIndicators && (<>{expectation.indicators.map(indicator => {
          return <Indicator key={indicator.id} indicator={indicator} withReferences={withReferences} />
        }
        )}</>)}
     </AccordionDetails>
    </Accordion>
  )
}

function accordionStyles() {
  return {
    root: {
      boxShadow: 'none'
    }
  }
}

function accordionSummaryStyles () {
  return {
    root: {
      backgroundColor: '#f0f8fb',
      color: '#4a5760',
      fontSize: '12pt',
      display: 'flex',
      padding: '0 24px'
    },
    content: {
      display: 'flex',
      flexDirection: 'column'
    }
  }
}

function accordionDetailStyles() {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: 0
    }
  }
}

function styles () {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '8px 10px'
    },
    centered: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center'
    },
    description: {
      flexGrow: 1,
      marginRight: 8, 
      marginBottom: 5
    }
  }
}

